
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cvtheque",
      function () {
        return require("private-next-pages/cvtheque/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cvtheque"])
      });
    }
  